module.exports = __webpack_public_path__ + "static/media/15UN-Habitat4.f5af1f85.jpg";